import React, { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../components/Link';
import { SvgPlayFilled } from '../../../icons';
import { SingleRecording } from '../../../queries/ats/recordings/types/recording';
import { routes } from '../../../routes/route-utils';
import styles from './details-button.module.scss';

interface WatchRecordingButtonProps {
  recording: SingleRecording;
}

export const WatchRecordingButton = forwardRef<HTMLAnchorElement, WatchRecordingButtonProps>(({ recording }, ref) => {
  const { t } = useTranslation();

  return (
    <Link ref={ref} to={routes.recording(recording)} className={styles.secondary}>
      <SvgPlayFilled /> {t('see recording')}
    </Link>
  );
});
